import { createSimpleMaterializer, createMaterializer } from '@wix/materializer'
import {
	MegaStoreWithSubscriptions,
	CatharsisMegaStoreSymbol,
	getInvalidationHandler,
} from '@wix/thunderbolt-catharsis'
import {
	appConstant,
	CatharsisStructureStoreSymbol,
	CompNodeProviderSymbol,
	DataNodeProviderSymbol,
	MaterializerFactorySymbol,
	OnInvalidationSymbol,
} from '@wix/thunderbolt-catharsis-ioc'
import { shapeIdsDataNodes, cursorShapeIdsNode, shapeIdsNode } from '@wix/thunderbolt-fetch-shapes'
import { PresetDataNode } from '@wix/thunderbolt-fetch-presets'
import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { withDependencies } from '@wix/thunderbolt-ioc'
import type { Data } from '@wix/thunderbolt-becky-types'

const MaterializerFactory = withDependencies(
	[appConstant('experiments'), appConstant('isEditor')] as const,
	(experiments, isEditor) => {
		return !isEditor ? createSimpleMaterializer : createMaterializer
	}
)

const RELEVANT_DATA_MAPS: Array<keyof Data> = [
	'document_data',
	'design_data',
	'component_properties',
	'theme_data',
	'cursor',
]

export const commonLoader: ContainerModuleLoader = (bind) => {
	const megaStore = new MegaStoreWithSubscriptions()
	bind(CatharsisMegaStoreSymbol).toConstantValue(megaStore)
	bind(CatharsisStructureStoreSymbol).toConstantValue(megaStore.getChildStore('structure'))
	bind(OnInvalidationSymbol).toConstantValue(getInvalidationHandler(megaStore))
	bind(DataNodeProviderSymbol).toConstantValue(shapeIdsDataNodes)
	bind(DataNodeProviderSymbol).toConstantValue(PresetDataNode)
	bind(CompNodeProviderSymbol).toConstantValue({
		getCompNodes: () => ({ shapeIds: shapeIdsNode, cursorShapeIds: cursorShapeIdsNode }),
		getUsedDataMaps: () => RELEVANT_DATA_MAPS,
	})
	bind(MaterializerFactorySymbol).to(MaterializerFactory)
}
